import React, { useEffect, useState } from "react";
import Logo from "../../assest/Logo.svg";
import dashIcon from "../../assest/icons/dashboard.svg";
import happyhourIcon from "../../assest/images/bottle.png";
import settings from "../../assest/icons/settings.svg";
import bussinessIcon from "../../assest/icons/Business.svg";
import supportIcon from "../../assest/icons/support.svg";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { logOut } from "../../redux/slices/userSlices";
import { useDispatch, useSelector } from "react-redux";

function Sidebar({ open, openSupportHandler }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const Links = [
    // { item: "Dashboard", href: "/dashboard", icon: dashIcon },
    {
      item: "Business Info",
      href: "/dashboard/business_info",
      icon: bussinessIcon,
    },
    {
      item: "Happy Hours",
      href: "/dashboard/happy_hours_info",
      icon: happyhourIcon,
    },

    { item: "Settings", href: "/dashboard/settings", icon: settings },
  ];

  const handleLogout = () => {
    dispatch(logOut());
    // Optionally, navigate to the login page after logout
    navigate("/login");
  };
  const isActive = (link) => location.pathname === link;

  return (
    <aside
      id="default-sidebar"
      className="fixed top-0 left-0 z-40 w-64 h-screen transition-transform -translate-x-full sm:translate-x-0 border-r-2
       border-r-white border-opacity-20"
      aria-label="Sidebar"
    >
      <div className="h-fit px-3 py-4 overflow-y-auto bg-bg-main ">
        <ul className="space-y-2 font-medium">
          <li>
            <Link
              to={"/"}
              className="flex items-center p-2 text-gray-900 rounded-lg my-4 group"
            >
              <img src={Logo} alt="scout-sip" />
            </Link>
          </li>

          {Links.map((link, index) => {
            return (
              <li key={index}>
                <Link
                  to={link.href}
                  className={`flex items-center p-2 text-gray-900 rounded-lg text-white group ${
                    isActive(link.href)
                      ? "bg-darkgreen hover:bg-transparent"
                      : "hover:bg-darkgreen"
                  }`}
                >
                  <img src={link.icon} alt={link.item} className="w-5 h-5" />
                  <span className="flex-1 ms-3 whitespace-nowrap">
                    {link.item}
                  </span>
                </Link>
              </li>
            );
          })}
        </ul>
        <div className="h-[1px] w-full mx-auto bg-white opacity-25 my-5" />

        <div className="boosted-happy-hour">
          <svg
            width="30"
            height="35"
            viewBox="0 0 30 35"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M29.0807 12.9771L17.2241 1.12046C15.9984 -0.105305 14.0038 -0.105375 12.7779 1.12046C11.676 2.22233 11.5811 3.90283 12.3948 5.10281L12.3783 5.18534C11.5235 9.45981 9.44244 13.3484 6.35992 16.4309L0.921606 21.8692C-0.307097 23.098 -0.307307 25.0866 0.921606 26.3154L3.88567 29.2794C5.1143 30.5081 7.10307 30.5082 8.33184 29.2794L9.07289 28.5384L14.2601 33.7256C15.4888 34.9544 17.4774 34.9544 18.7062 33.7256C19.932 32.4998 19.932 30.5053 18.7062 29.2795L16.4831 27.0564L17.2242 26.3154C18.4529 25.0867 18.453 23.0981 17.2242 21.8693L16.7206 21.3656C19.1979 19.6312 22.0114 18.4236 25.0159 17.8227L25.0995 17.806C26.3262 18.6342 28.0028 18.5011 29.0807 17.4231H29.0808C30.3064 16.1974 30.3064 14.2029 29.0807 12.9771ZM6.84981 27.7974C6.44029 28.2069 5.77723 28.2069 5.3677 27.7973L2.40364 24.8333C1.99405 24.4236 1.99405 23.7608 2.40364 23.3512L7.59079 18.164L12.037 22.6102C11.5295 23.1177 7.36981 27.2773 6.84981 27.7974ZM17.2241 30.7615C17.6327 31.17 17.6327 31.8349 17.2241 32.2435C16.8156 32.652 16.1506 32.652 15.7421 32.2435L10.5549 27.0563L12.037 25.5742L17.2241 30.7615ZM13.519 24.0922C13.834 23.7772 14.3056 23.2946 15.0499 22.659L15.7421 23.3512C16.1517 23.7608 16.1517 24.4236 15.7421 24.8333L15.001 25.5743L13.519 24.0922ZM13.5635 21.1727L9.02817 16.6374C11.4587 13.8309 13.1992 10.5181 14.1304 6.91903L23.2819 16.0705C19.6828 17.0016 16.3701 18.7422 13.5635 21.1727ZM27.5985 15.941C27.1889 16.3505 26.526 16.3505 26.1164 15.941L14.26 4.08453C13.8504 3.67487 13.8504 3.01209 14.26 2.6025C14.6696 2.1929 15.3325 2.1929 15.7421 2.6025L27.5985 14.4589C28.007 14.8675 28.007 15.5323 27.5985 15.941Z"
              fill="#F2EADF"
            />
          </svg>
          <span className="font-semibold text-xl">Boosted Happy Hours</span>
        </div>

        <div className="flex gap-y-4 flex-col fixed bottom-4">
          <button
            onClick={openSupportHandler}
            className={`cursor-pointer w-fit border-2 border-transparent rounded-full hover:border-main-orange-200 ${
              open && "border-main-orange-200"
            }`}
          >
            <img className="w-14 h-14" src={supportIcon} alt="alt" />
          </button>
          <div className="w-full">
            <button
              className="flex items-center p-2 text-gray-900 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-darkgreen group w-full cursor-pointer"
              onClick={handleLogout}
            >
              <svg
                className="flex-shrink-0 w-5 h-5 text-gray-500 transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-white"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 18 16"
              >
                <path
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M1 8h11m0 0L8 4m4 4-4 4m4-11h3a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-3"
                />
              </svg>
              <span className="flex-1 ms-3 whitespace-nowrap">Log Out</span>
            </button>
          </div>
        </div>
      </div>
    </aside>
  );
}

export default Sidebar;
